var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.824 109.664H31.617L24.012 96.488L10.836 88.883V73.673L3.23096 60.5L10.836 47.327V32.117L24.012 24.512L31.617 11.336H46.824L60 3.73096L73.176 11.336H88.383L95.988 24.512L109.164 32.117V47.327L116.769 60.5L109.164 73.673V88.883L95.988 96.488L88.383 109.664H73.176L60 117.269L46.824 109.664Z",
    fill: "#FFBE1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 5.465L72.075 12.437L72.771 12.839H73.575H87.519L94.491 24.914L94.89 25.61L95.586 26.012L107.661 32.984V46.928V47.732L108.063 48.428L115.035 60.5L108.063 72.575L107.661 73.271V74.075V88.019L95.586 94.991L94.89 95.39L94.488 96.086L87.516 108.161H73.572H72.768L72.072 108.563L60 115.535L47.925 108.563L47.229 108.161H46.425H32.481L25.509 96.086L25.11 95.39L24.414 94.988L12.339 88.016V74.072V73.268L11.937 72.572L4.965 60.5L11.937 48.425L12.339 47.729V46.925V32.981L24.414 26.009L25.11 25.61L25.512 24.914L32.484 12.839H46.428H47.232L47.928 12.437L60 5.465ZM60 2L46.425 9.836H30.75L22.911 23.411L9.339 31.25V46.925L1.5 60.5L9.339 74.075V89.75L22.914 97.586L30.753 111.161H46.428L60 119L73.575 111.164H89.25L97.089 97.589L110.664 89.753V74.078L118.5 60.5L110.661 46.925V31.25L97.086 23.411L89.25 9.836H73.575L60 2Z",
    fill: "#1A1919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 60.4439L52.3842 76L87 41",
    stroke: "#070707",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.796e1140ec818a8e1b8bb36ba6d777c7.svg";
export { ForwardRef as ReactComponent };